import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6600d61b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6600d61b')) {
      api.createRecord('6600d61b', component.options)
    } else {
      api.reload('6600d61b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6600d61b", function () {
      api.rerender('6600d61b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fetch-user/index.vue"
export default component.exports